import React, { useEffect, useState, useContext } from 'react'
import { useFetch } from '../../api/FetchApiData';
import './cat-form.css';
import { isMobile } from 'react-device-detect';
import { TeachButton } from '../../utils/ButtonLoader';
import { useNavigate } from 'react-router-dom';
if (isMobile)
    import('./mob-cat-form.css').then(() => {});
else
    import('./cat-form.css').then(() => {});


function CategoryForm({close=()=>{}, action,category={name:'',id: null,characteristics:[],dimensionnements:[]},rayon, setRayons}) {
    const [_category,setCategory] = useState(category);
    const fectch = useFetch();
    const [notification,setNotification] = useState({text:'',color:'black'});
    const navigator = useNavigate();

    useEffect(()=>{
        if(action==="Modifier")
        {setCategory({...category});}
    },[category])


    const Updata_Data = (close)=>
    {
        if(!!_category.id)
        {
            const _category_ = {..._category};
            console.log(_category_);
            fectch.PutData(_category_,'category/').then((result)=>{
                if(result.result)
                {
                    setNotification({text:"Categorie mise à jour", color:'green'});
                    setTimeout(()=>{setNotification({text:'',color:'black'});close();setRayons([...result.rayons])},3000);
                }
                else
                {
                    setNotification({text:result.errors[0],color:'red'});
                    setTimeout(()=>{setNotification({text:'',color:'black'});},3000);
                }
            });
        }
    }

    const Delete_Data = (close)=>{
    }

    const ExecAction = (close)=>
    {
        if(action==="Modifier")
        {Updata_Data(close);}
        else
            Delete_Data(close);
    }

    let trigger_color = (action==="Supprimer") ? '#FFCCCB' : 'lightgreen';
    trigger_color = (action==="Modifier") ? 'lightblue' : trigger_color; 

    const Form = (close)=>
    {
        if(action==="Nouveau" || action==="Modifier")
        {
            return(
            <>
                <div style={{textAlign:'center'}} className='cat-div-input'>
                    <p style={{color:notification.color}}>{notification.text}</p>
                </div>
                <div  className="cat-div-input">
                    <label className='cat-label' >Rayon : </label>
                    <input style={{border:'1px solid lightgray'}} disabled type='text' value={rayon.name} className='cat-user-input' />
                </div>
                <div className="cat-div-input">
                    <label className='cat-label'>Name : </label>
                    <input type='text' style={{border:'1px solid lightgray'}} value={category.name} className='cat-user-input' />
                </div>
                <div className="cat-div-input">
                    <label className='cat-label'>Caractérisques : </label>
                    <div className='cat-car-div'>
                        {
                            _category.characteristics.map((car,index)=>{
                                return(
                                    <div style={{width:'100%',marginTop:'5px'}}>
                                        <input className='cat-car-input' name={index.toString()} placeholder = 'name' value={_category.characteristics[index].name}  onChange={e=>{_category.characteristics[index].name = e.target.value; setCategory({..._category});}} type="text"/>
                                        <input className='cat-car-input' name={index.toString()} placeholder = 'default value' value={_category.characteristics[index].default_value}  onChange={e=>{_category.characteristics[index].default_value = e.target.value; setCategory({..._category});}} type="text"/>
                                        <input onClick={e=>{_category.characteristics.splice(index,1);setCategory({..._category})}} name={index.toString()} style={{backgroundColor:'#FFCBCC',margin:'2px',borderRadius:'5px',border:'none',width:'22%',display:'inline-block',height:'35px',padding:'0px 10px 0px 10px',margin:'0px'}} type='button' value={"supprimer"} />
                                    </div>)
                            })
                        }
                        <input onClick={e=>{category.characteristics.push({name:'name',default_value: 'default value'});setCategory({...category})}} type='button' value={'Ajouter'} style={{margin:'10px',width:'70%',height:'35px',borderRadius:'5px',backgroundColor:'whitesmoke'}} />
                    </div>
                </div>
                <div className="cat-div-input">
                    <label className='cat-label'>Dimensionnement : </label>
                    <div className='cat-car-div'>
                        {
                            _category.dimensionnements.map((car,index)=>{
                                return(
                                    <div style={{width:'100%',marginTop:'5px'}}>
                                        <input className='dim-input' name={index.toString()} placeholder = 'name' value={_category.dimensionnements[index].name}  onChange={e=>{_category.dimensionnements[index].name = e.target.value; setCategory({..._category});}} type="text"/>
                                        <input className='dim-input' name={index.toString()} placeholder = 'default value' value={_category.dimensionnements[index].value}  onChange={e=>{_category.dimensionnements[index].value = e.target.value; setCategory({..._category});}} type="text"/>
                                        <input className='dim-input' name={index.toString()} placeholder = 'unite' value={_category.dimensionnements[index].unite}  onChange={e=>{_category.dimensionnements[index].unite = e.target.value; setCategory({..._category});}} type="text"/>
                                        <input onClick={e=>{_category.dimensionnements.splice(index,1);setCategory({..._category})}} name={index.toString()} style={{backgroundColor:'#FFCBCC',margin:'2px',borderRadius:'5px',border:'none',width:'22%',display:'inline-block',height:'35px',padding:'0px 10px 0px 10px',margin:'0px',fontSize:'x-small'}} type='button' value={"supprimer"} />
                                    </div>)
                            })
                        }
                        <input onClick={e=>{category.dimensionnements.push({name:'name',value: 'value',unite:'unite'});setCategory({...category})}} type='button' value={'Ajouter'} style={{margin:'10px',width:'70%',height:'35px',borderRadius:'5px',backgroundColor:'whitesmoke'}} />
                    </div>
                </div>
                <div style={{textAlign:'center'}} className='cat-div-input'>
                    <input onClick={e=>{ExecAction(close);}} style={{margin:'10px',height:'40px',minWidth:'20%',border:'none',padding:'5px',borderRadius:'5px',backgroundColor:trigger_color}} type='button' value={"Enregister"} />
                    <input onClick={close} style={{margin:'10px',height:'40px',minWidth:'20%',border:'none',padding:'5px',borderRadius:'5px',backgroundColor:'orangered'}} type='button' value={"Annuler"} />
                    <TeachButton id={category.id} target={'category'} width={'50%'} />
                </div>
            </>);
        }
    }

    if(category.id===null || category.id===undefined)
        return(
        <div style={{backgroundColor:'rgba(0,0,0,0.8)',position:'fixed',top:'0px',left:'0px',width:'100%',height:'100vh'}}>
            <fieldset className='cat-fieldset'>
                <label style={{color:'orangered'}}>Aucune categorie sélectionnée</label><br/>
                <input type='button' style={{height:'25px',padding:'5px 20px 5px 20px',marginTop:'10px'}} value={'OK'} onClick={e=>{close()}} />
            </fieldset>
        </div>
        );

    if(rayon.id==='' || rayon.id===null || rayon.id===undefined)
        return(
        <div style={{backgroundColor:'rgba(0,0,0,0.8)',position:'fixed',top:'0px',left:'0px',width:'100%',height:'100vh'}}>
            <fieldset className='cat-fieldset'>
                <label style={{color:'orangered'}}>Aucun rayon n'a été sélectionné</label><br/>
                <input type='button' style={{height:'25px',padding:'5px 20px 5px 20px',marginTop:'10px'}} value={'OK'} onClick={e=>{close()}} />
            </fieldset>
        </div>
        );

  return (
    <div style={{backgroundColor:'rgba(0,0,0,0.8)',position:'fixed',top:'0px',left:'0px',width:'100%',height:'100vh'}}>
        <fieldset className='cat-fieldset'>
            {Form(close)}
        </fieldset>
    </div>)
}

export default CategoryForm;
